const e=2e4;function t(e){let t=0;let n=e.next(t);for(;!n.done&&t<2e4;)t+=50,n=e.next(t);return t>=2e4?1/0:t}export{t as calcGeneratorDuration,e as maxGeneratorDuration};
